_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[26],{

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j36g");
module.exports = __webpack_require__("rPjH");


/***/ }),

/***/ "P5Wp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("KQm4");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__("h4VS");

// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__("lTCR");
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__("ttZb");

// EXTERNAL MODULE: ./components/Loading.js
var Loading = __webpack_require__("VFWX");

// EXTERNAL MODULE: ./util/markup.js
var markup = __webpack_require__("jZu3");

// EXTERNAL MODULE: ./lib/wordpress.js
var wordpress = __webpack_require__("xWpn");

// EXTERNAL MODULE: ./node_modules/react-infinite-scroller/index.js
var react_infinite_scroller = __webpack_require__("RotF");
var react_infinite_scroller_default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller);

// EXTERNAL MODULE: ./components/Teaser.js
var Teaser = __webpack_require__("KIk8");

// EXTERNAL MODULE: ./components/Layout/PostGrid.js
var PostGrid = __webpack_require__("+Hjb");

// EXTERNAL MODULE: ./components/Avatar.js
var Avatar = __webpack_require__("wtrr");

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__("g4pe");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: ./util/link.js
var util_link = __webpack_require__("XEHS");

// EXTERNAL MODULE: ./node_modules/rebass/dist/index.js
var dist = __webpack_require__("QKO/");

// EXTERNAL MODULE: ./components/Styles/Paragraph.js
var Paragraph = __webpack_require__("rBKS");

// CONCATENATED MODULE: ./components/Author.js








function _templateObject2() {
  var data = Object(taggedTemplateLiteral["a" /* default */])(["\n  query POST_BY_AUTHOR_QUERY($author: Int, $cursor: String) {\n    posts(where: { author: $author }, first: 10, after: $cursor) {\n      edges {\n        node {\n          id\n          title\n          link: uri\n          date\n          commentCount\n          categories {\n            edges {\n              node {\n                name\n                slug\n              }\n            }\n          }\n          featuredImage {\n            node {\n              mediaDetails {\n                sizes {\n                  name\n                  sourceUrl\n                  width\n                  height\n                }\n              }\n            }\n          }\n          excerpt(format: RAW)\n          author {\n            node {\n              name\n              slug\n            }\n          }\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = Object(taggedTemplateLiteral["a" /* default */])(["\n  query AUTHOR_QUERY($name: String!) {\n    user: userByName(name: $name) {\n      userId\n      name\n      description\n      customAvatar\n      quotes\n      firstName\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}















var Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Author__Content",
  componentId: "n947iv-0"
})(["p{margin-bottom:2rem;line-height:2.6rem;}strong{font-weight:bold;}"]);
var AUTHOR_QUERY = src_default()(_templateObject());
var POSTS_BY_AUTHOR_QUERY = src_default()(_templateObject2());
var AuthorWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Author__AuthorWrapper",
  componentId: "n947iv-1"
})(["padding-top:4rem;max-width:", ";margin:0 auto;display:grid;grid-template-columns:1fr 3fr;grid-gap:3rem;h1{font-size:3rem;text-align:center;margin-bottom:3rem;}h2{font-size:2rem;text-align:center;margin-bottom:3rem;cursor:pointer;}@media screen and (max-width:500px){grid-template-columns:1fr;padding:15px;padding-top:2rem;}.info{text-align:center;}"], function (props) {
  return props.theme.maxWidth;
});
var Posts = Object(styled_components_browser_esm["default"])(PostGrid["a" /* default */]).withConfig({
  displayName: "Author__Posts",
  componentId: "n947iv-2"
})(["width:100%;max-width:1600px;"]);

var Author_PostsList = function PostsList(_ref) {
  var author = _ref.author;

  var _useQuery = Object(react_hooks_esm["c" /* useQuery */])(POSTS_BY_AUTHOR_QUERY, {
    variables: {
      author: author
    }
  }),
      data = _useQuery.data,
      error = _useQuery.error,
      loading = _useQuery.loading,
      fetchMore = _useQuery.fetchMore;

  if (loading) {
    return /*#__PURE__*/Object(jsx_runtime["jsx"])(Loading["a" /* default */], {});
  }

  if (error) {
    return null;
  }

  var posts = data.posts;
  return /*#__PURE__*/Object(jsx_runtime["jsx"])(Posts, {
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])(react_infinite_scroller_default.a, {
      hasMore: posts.pageInfo.hasNextPage,
      loadMore: function loadMore() {
        fetchMore({
          variables: {
            cursor: posts.pageInfo.endCursor
          },
          updateQuery: function updateQuery(previousResult, _ref2) {
            var fetchMoreResult = _ref2.fetchMoreResult;
            var newEdges = fetchMoreResult.posts.edges;
            var pageInfo = fetchMoreResult.posts.pageInfo;
            return newEdges.length ? {
              // Put the new comments at the end of the list and update `pageInfo`
              // so we have the new `endCursor` and `hasNextPage` values
              posts: {
                __typename: previousResult.posts.__typename,
                edges: [].concat(Object(toConsumableArray["a" /* default */])(previousResult.posts.edges), Object(toConsumableArray["a" /* default */])(newEdges)),
                pageInfo: pageInfo
              }
            } : previousResult;
          }
        });
      },
      children: posts.edges.map(function (post, index) {
        return /*#__PURE__*/Object(jsx_runtime["jsx"])(Teaser["a" /* default */], {
          post: post.node,
          position: index % 2 === 0 ? "left" : "right"
        }, "post-".concat(index));
      })
    })
  });
};

var _StyledBox = Object(styled_components_browser_esm["default"])(dist["Box"]).withConfig({
  displayName: "Author___StyledBox",
  componentId: "n947iv-3"
})(["background-color:", ";em{text-align:left;strong{display:block;margin-bottom:1rem;}p{margin-bottom:3rem;}}"], function (p) {
  return p.theme.white;
});

var Author_Quotes = function Quotes(_ref3) {
  var quotes = _ref3.quotes;

  if (quotes.trim() === "") {
    return null;
  }

  return /*#__PURE__*/Object(jsx_runtime["jsx"])(_StyledBox, {
    py: 2,
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])(Paragraph["a" /* default */], {
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])("blockquote", {
        children: /*#__PURE__*/Object(jsx_runtime["jsx"])("em", {
          dangerouslySetInnerHTML: Object(markup["b" /* createMarkup */])(quotes)
        })
      })
    })
  });
};

var _StyledParagraph = Object(styled_components_browser_esm["default"])(Paragraph["a" /* default */]).withConfig({
  displayName: "Author___StyledParagraph",
  componentId: "n947iv-4"
})(["p{margin-bottom:1.5rem;}margin-top:0;"]);

var Author_Author = function Author(_ref4) {
  var name = _ref4.name;

  var _useQuery2 = Object(react_hooks_esm["c" /* useQuery */])(AUTHOR_QUERY, {
    variables: {
      name: name
    }
  }),
      data = _useQuery2.data,
      error = _useQuery2.error,
      loading = _useQuery2.loading;

  if (loading) {
    return /*#__PURE__*/Object(jsx_runtime["jsx"])(Loading["a" /* default */], {});
  }

  if (error) {
    return null;
  }

  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(jsx_runtime["Fragment"], {
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(head_default.a, {
      children: /*#__PURE__*/Object(jsx_runtime["jsxs"])("title", {
        children: [data.user.name, " | Modepilot.de "]
      })
    }), /*#__PURE__*/Object(jsx_runtime["jsxs"])(AuthorWrapper, {
      children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
        className: "info",
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h1", {
          children: data.user.name
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])(Avatar["a" /* default */], {
          src: Object(util_link["d" /* removeDomain */])(data.user.customAvatar)
        })]
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])(_StyledParagraph, {
        dangerouslySetInnerHTML: Object(markup["b" /* createMarkup */])(data.user.description)
      })]
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])(Author_Quotes, {
      quotes: data.user.quotes
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])(Author_PostsList, {
      author: data.user.userId
    })]
  });
};

/* harmony default export */ var components_Author = (Author_Author);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// CONCATENATED MODULE: ./pages/author/[name].js






var Article = styled_components_browser_esm["default"].article.withConfig({
  displayName: "name__Article",
  componentId: "sc-19u2hxi-0"
})(["padding-top:4rem;"]);

function Page(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/Object(jsx_runtime["jsx"])(Article, {
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])(components_Author, {
      name: name
    })
  });
}

Page.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
    var query;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref2.query;
            return _context.abrupt("return", {
              name: query.name
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

/* harmony default export */ var _name_ = __webpack_exports__["default"] = (Page);

/***/ }),

/***/ "rBKS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("vOnD");
/* harmony import */ var rebass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QKO/");
/* harmony import */ var rebass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(rebass__WEBPACK_IMPORTED_MODULE_3__);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var _StyledText = Object(styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(rebass__WEBPACK_IMPORTED_MODULE_3__["Text"]).withConfig({
  displayName: "Paragraph___StyledText",
  componentId: "sc-3urum6-0"
})(["max-width:", ";strong{font-size:", ";", "}em{font-style:italic;}a{", " text-decoration:underline;font-style:italic;}h2{margin-top:3rem;margin-bottom:0;", " font-size:3rem;line-height:4rem;font-weight:normal;}h3{margin-top:4rem;margin-bottom:0;", " font-size:2.5rem;line-height:4rem;font-weight:normal;}blockquote,span{", "}blockquote{border-left:5px solid ", ";margin-left:3rem;padding-left:3rem;}img{max-width:100%;height:auto;}"], function (props) {
  return props.theme.contentMaxWidth;
}, function (props) {
  return props.theme.fontSizes[3];
}, function (props) {
  return props.theme.fontSans;
}, function (props) {
  return props.theme.fontSans;
}, function (props) {
  return props.theme.fontSerif;
}, function (props) {
  return props.theme.fontSerif;
}, function (props) {
  return props.theme.fontSans;
}, function (props) {
  return props.theme.highlight;
});

var Paragraph = function Paragraph(props) {
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_StyledText, _objectSpread(_objectSpread({
    as: "div"
  }, props), {}, {
    fontFamily: "sans",
    lineHeight: "copy",
    mx: "auto",
    my: 4,
    fontSize: 3
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (Paragraph);

/***/ }),

/***/ "rPjH":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/[name]",
      function () {
        return __webpack_require__("P5Wp");
      }
    ]);
  

/***/ }),

/***/ "wtrr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vOnD");

var Avatar = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].img.withConfig({
  displayName: "Avatar",
  componentId: "sc-18dn49q-0"
})(["width:", ";height:", ";margin:1rem auto;border-radius:50%;border:2px solid ", ";box-shadow:0 6px 4px -4px ", ";display:block;"], function (props) {
  return props.about ? "220px;" : "163px";
}, function (props) {
  return props.about ? "220px;" : "163px";
}, function (props) {
  return props.theme.highlight;
}, function (props) {
  return props.theme.grey;
});
/* harmony default export */ __webpack_exports__["a"] = (Avatar);

/***/ })

},[[11,0,1,2,3,4,5,7,6,8,10,9,11]]]);